<app-navbar customHeader="true">
  <div class="container-fluid bg-light mh-100">
    <div class="col-12 d-flex justify-content-center ">
      <div class="row mt-4">
        <h2 class="title-page ">
          Cadastre-se
        </h2>
      </div>
    </div>
    <div class="row d-flex justify-content-center col-12">
      <app-selecao-tipo-usuario *ngIf="!hasForm" (tipoSelecionado)="onTipoSelecionado($event)" (voltar)="backStep()"></app-selecao-tipo-usuario>
      <app-cadastro-usuario *ngIf="hasForm" [typeForm]="typeForm" (voltar)="onVoltar()"></app-cadastro-usuario>
    </div>
  </div>
</app-navbar>
<app-footer></app-footer>
